<div class="comment-list">
  <div class="comment-item-wrapper" *ngFor="let comment of comments; trackBy: trackByCommentId">
    <ptl-comment-item
      [comment]="comment"
      [momentId]="momentId"
      [isTopLevel]="true"
      [currentUserId]="currentUserId"
      (commentUpdated)="onCommentUpdated($event)"
      (commentDeleted)="onCommentDeleted($event)"
      (commentLiked)="onCommentLiked($event.commentId, $event.isLiked)"
      (replyCreated)="onReplyCreated($event.reply, $event.parentCommentId, $event.replyingToAuthorName)"
    >
    </ptl-comment-item>
  </div>
</div>
